import { useEffect, useState } from 'react'
import { getFromApi } from 'actions'
import { validateDocumentNumber } from 'utils/utils'

const testDocLengthValidation = (documentType, documentNumber) => !validateDocumentNumber(documentType, documentNumber)

export const useDocumentTypeList = () => {
   const [docTypeList, setDocTypeList] = useState([])

   useEffect(() => {
      const fetchData = async () => {
         const url = `${process.env.REACT_APP_LOGIN_API}/users/usertype?userType=all`
         const data = await getFromApi(url)
         setDocTypeList(
            data?.map(doc => ({ ...doc, value: doc?.code, label: `${doc?.code} - ${doc?.description}` })) || []
         )
      }
      fetchData()
   }, [])

   return { docTypeList, testDocLengthValidation }
}
